import verticalSymbols from "../symbols/verticals";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function VerticalSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case verticalSymbols.GET_VERTICALS:
      return { ...state, loading: true, error: false };
    case verticalSymbols.GET_VERTICALS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case verticalSymbols.GET_VERTICALS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case verticalSymbols.CLEAR_GET_VERTICALS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
